module.exports = __webpack_public_path__ + "static/media/Custom_Payment.5b0d8aab.svg";